// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b

// Only allow internal paths ("/xxx"), reject "//host" and "/\host" (protocol-relative URLs)
export const getSafeCallbackUrl = (url, fallback = '/') => {
  if (typeof url !== 'string' || !url.startsWith('/') || /^\/[/\\]/.test(url)) {
    return fallback;
  }
  return url;
};
